import * as React from "react";
const SvgFiRrPaid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-paid_svg__a)">
      <path
        fill="#062147"
        d="M18.7 9.6a.7.7 0 0 1 .7.7v3.4a.7.7 0 0 1-.7.7H18V9.598h.7zm-12.701.9c0-.496-.404-.9-.9-.9h-.5v1.8h.5c.496 0 .9-.404.9-.9m3.612 2.501h1.261l-.638-3.295zM23.999 9v6a3 3 0 0 1-1.34 2.497C20.612 21.458 16.475 24 11.999 24s-8.613-2.542-10.66-6.503A3 3 0 0 1-.001 15V9c0-1.043.533-1.959 1.34-2.497C3.387 2.542 7.524 0 12 0s8.613 2.542 10.66 6.503A3 3 0 0 1 23.999 9m-5.3-1h-1.5a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8h1.5a2.3 2.3 0 0 0 2.3-2.3v-3.4a2.3 2.3 0 0 0-2.3-2.3M4.034 6h15.929c-1.823-2.42-4.701-4-7.965-4S5.857 3.58 4.034 6m10.565 2a.8.8 0 0 0-.8.8v6.4a.8.8 0 1 0 1.6 0V8.8a.8.8 0 0 0-.8-.8m-2.998 1.193c-.12-.668-.589-1.192-1.346-1.192s-1.281.587-1.385 1.167l-1.2 5.976a.716.716 0 1 0 1.406.272l.166-.889h2.006l.157.883a.716.716 0 0 0 .705.591h.01a.716.716 0 0 0 .701-.86L11.6 9.194zM3.798 16a.8.8 0 0 0 .8-.8V13h.5a2.5 2.5 0 0 0 2.5-2.452C7.624 9.147 6.444 8 5.042 8H3.798a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8m16.165 2H4.035c1.823 2.42 4.701 4 7.965 4s6.142-1.58 7.965-4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-paid_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPaid;
